// @ts-strict-ignore
import { isEmpty, isNil } from 'lodash';

export function getDefaultViewTemplateId(viewTemplates: MBAPI.ViewTemplate[]): string {
  if (!isNil(viewTemplates)) {
    const viewTemplate = viewTemplates?.find(isDefaultViewTemplate);
    return viewTemplate?.id;
  }
  return null;
}

function isDefaultViewTemplate(viewTemplate: MBAPI.ViewTemplate): boolean {
  return viewTemplate.type === 'CARD' && !viewTemplate.isPublic;
}

export function countCompletedSubformFields(
  components: MBAPI.WorkflowTemplate_components[],
  data: Record<string, any>,
): number {
  const componentIds = isEmpty(components) ? [] : components.map(component => component.id);
  const keys = isNil(data) ? [] : Object.keys(data);
  let count = 0;
  for (const key of keys) {
    if (componentIds.includes(key) && hasAuditComponentValue(data[key])) {
      count += 1;
    }
  }
  return count;
}

function hasAuditComponentValue(value: any): boolean {
  return !isEmpty(value.tags) || (!isNil(value.checked) && value.checked) || !isEmpty(value.text);
}
